import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { ToastProvider } from '@/context/Toast';
import { RequestRouter } from './views';
import i18n from '../i18n';
import RequestContextProvider from './store/request-provider';

const queryClient = new QueryClient();
const aliasAccount = window.location.host.split('.')[0];
const templateLinkUnavailable =
  document.querySelector('meta[name="hiringroom:templateLinkUnavailable"]')?.getAttribute('content') === '1';
const editLinkUnavailable =
  document.querySelector('meta[name="hiringroom:editLinkUnavailable"]')?.getAttribute('content') === '1';
const reCaptcha = document.querySelector('meta[name="hiringroom:recapcha"]')?.getAttribute('content');
const IntercomProductTourId = document.querySelector('meta[name="hiringroom:productTourId"]')?.getAttribute('content');
const bannerShowMeta = document.querySelector('meta[name="hiringroom:bannerShow"]')?.getAttribute('content');
const bannerShow = bannerShowMeta === '1' || bannerShowMeta === 'true';

function mountVacancyRequestApp() {
  ReactDOM.render(
    <I18nextProvider i18n={i18n} key='translate'>
      <RequestContextProvider>
        <QueryClientProvider client={queryClient}>
          <GoogleReCaptchaProvider
            useRecaptchaNet
            useEnterprise
            reCaptchaKey={reCaptcha}
            scriptProps={{ async: true, defer: true, appendTo: 'body' }}
          >
            <ToastProvider>
              <RequestRouter
                aliasAccount={aliasAccount}
                IntercomProductTourId={IntercomProductTourId}
                bannerShow={bannerShow}
                templateLinkUnavailable={templateLinkUnavailable}
                editLinkUnavailable={editLinkUnavailable}
              />
            </ToastProvider>
          </GoogleReCaptchaProvider>
        </QueryClientProvider>
      </RequestContextProvider>
    </I18nextProvider>,
    document.getElementById('vacancyRequestApp')
  );
}

mountVacancyRequestApp();
